import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import styles from "./input-skeleton-loader.module.less";

const InputSkeletonLoader = () => (
  <div className={styles.wrapper}>
    <SkeletonTheme
      borderRadius={"var(--core-border-radius-default)"}
      baseColor={"var(--ctx-skeleton-loader-background"}
      highlightColor={"var(--ctx-skeleton-loader-highlights)"}
    >
      <Skeleton duration={1.8} className={styles.skeleton} />
    </SkeletonTheme>
  </div>
);

export default InputSkeletonLoader;
